const RESET_NEW_PASSWORD_BLURRED = 'RESET_NEW_PASSWORD_BLURRED';
const RESET_NEW_PASSWORD_FOCUSED = 'RESET_NEW_PASSWORD_FOCUSED';
const RESET_NEW_PASSWORD_SET = 'RESET_NEW_PASSWORD_SET';
const RESET_NEW_PASSWORD_CHANGE = 'RESET_NEW_PASSWORD_CHANGE';
const RESET_NEW_PASSWORD_SET_FOCUS = 'RESET_NEW_PASSWORD_SET_FOCUS';
const RESET_NEW_PASSWORD_SET_VALIDATION_MESSAGE = 'RESET_NEW_PASSWORD_SET_VALIDATION_MESSAGE';
const RESET_NEW_PASSWORD_SET_API_ERROR = 'RESET_NEW_PASSWORD_SET_API_ERROR';
const RESET_NEW_PASSWORD_SET_VISUALIZATION = 'RESET_NEW_PASSWORD_SET_VISUALIZATION';

const resetNewPasswordSet = (password) => ({
  type: RESET_NEW_PASSWORD_SET,
  payload: password
});

const resetNewPasswordSetFocus = (focused) => ({
  type: RESET_NEW_PASSWORD_SET_FOCUS,
  payload: focused
});

const resetNewPasswordSetValidationMessage = (validationMessage) => ({
  type: RESET_NEW_PASSWORD_SET_VALIDATION_MESSAGE,
  payload: validationMessage
});

const resetNewPasswordSetVisualization = (visualized) => ({
  type: RESET_NEW_PASSWORD_SET_VISUALIZATION,
  payload: visualized
});

const resetNewPasswordBlur = (markedAsWrong, validationMessage) => ({
  type: RESET_NEW_PASSWORD_BLURRED,
  payload: { markedAsWrong, validationMessage }
});

const resetNewPasswordFocus = () => ({
  type: RESET_NEW_PASSWORD_FOCUSED
});

const resetNewPasswordChange = (payload) => ({
  type: RESET_NEW_PASSWORD_CHANGE,
  payload
});

const resetNewPasswordSetApiError = (errors) => ({
  type: RESET_NEW_PASSWORD_SET_API_ERROR,
  payload: errors
});



export {
  RESET_NEW_PASSWORD_SET,
  RESET_NEW_PASSWORD_CHANGE,
  RESET_NEW_PASSWORD_SET_VALIDATION_MESSAGE,
  RESET_NEW_PASSWORD_SET_VISUALIZATION,
  RESET_NEW_PASSWORD_SET_FOCUS,
  RESET_NEW_PASSWORD_BLURRED,
  RESET_NEW_PASSWORD_FOCUSED,
  RESET_NEW_PASSWORD_SET_API_ERROR,
  resetNewPasswordSetApiError,
  resetNewPasswordBlur,
  resetNewPasswordFocus,
  resetNewPasswordSet,
  resetNewPasswordChange,
  resetNewPasswordSetVisualization,
  resetNewPasswordSetValidationMessage,
  resetNewPasswordSetFocus
};
